import { SignupStepperProps } from "./props.type";
import { MobileStepper, ThemeProvider, createTheme } from "@mui/material";
import { realityInfo } from "@/utils/realityInfo";
import Theme from "@/utils/theme";

const SignupStepper = ({ currentStep, skipResaleStep }: SignupStepperProps) => {
  const theme = createTheme({
    palette: {
      primary: { main: Theme.colors.brand.secondary },
    },
  });

  const steps = skipResaleStep ? 2 : 3;
  const activeStep = skipResaleStep
    ? currentStep >= 2
      ? 1
      : 0
    : currentStep;

  return (
    <>
      {realityInfo.showResaleCode && (
        <ThemeProvider theme={theme}>
          <MobileStepper
            steps={steps}
            position="static"
            activeStep={activeStep}
            nextButton={<></>}
            backButton={<></>}
            style={{ marginLeft: "-0.5rem" }}
          />
        </ThemeProvider>
      )}
    </>
  );
};

export default SignupStepper;
